import React from 'react';
import { ArticleAdviceCard } from '../ArticleAdviceCard';
import { ArticleAdviceCardHeader, ArticleAdviceCardHeaderValue } from '../ArticleAdviceCardHeader';
import { ArticleAdviceQuestion, ArticleAdviceQuestionValue } from '../ArticleAdviceQuestion';
import { Container } from '../Container';
import { SymptomList, SymptomListValue } from '../SymptomList';
export type HealthArticleSectionHealthExperienceValue = {
  header: ArticleAdviceCardHeaderValue;
  // Omitting displaying of user and date label
  question: Omit<ArticleAdviceQuestionValue, 'userLabel' | 'dateLabel'>;
  symptoms: SymptomListValue;
};
type Props = {
  value: HealthArticleSectionHealthExperienceValue;
};
export const HealthArticleSectionHealthExperience = ({
  value: {
    header,
    question,
    symptoms
  }
}: Props) => <ArticleAdviceCard data-sentry-element="ArticleAdviceCard" data-sentry-component="HealthArticleSectionHealthExperience" data-sentry-source-file="index.tsx">
    <ArticleAdviceCardHeader value={header} data-sentry-element="ArticleAdviceCardHeader" data-sentry-source-file="index.tsx" />
    <Container p={['16px', '24px']} data-sentry-element="Container" data-sentry-source-file="index.tsx">
      {!!symptoms?.length && <SymptomList value={symptoms} />}
      <ArticleAdviceQuestion value={question} data-sentry-element="ArticleAdviceQuestion" data-sentry-source-file="index.tsx" />
    </Container>
  </ArticleAdviceCard>;
export type HealthArticleSectionHealthExperienceProps = Props;